export const LIST_LAB_TEST_METHOD_SUMMARY_REQUEST = 'LIST_LAB_TEST_SUMMARY_REQUEST'
export const LIST_LAB_TEST_METHOD_SUMMARY_SUCCESS = 'LIST_LAB_TEST_SUMMARY_SUCCESS'
export const LIST_LAB_TEST_METHOD_SUMMARY_FAIL = 'LIST_LAB_TEST_SUMMARY_FAIL'

export const LIST_LAB_TEST_METHOD_REQUEST = 'LIST_LAB_TEST_METHOD_REQUEST'
export const LIST_LAB_TEST_METHOD_SUCCESS = 'LIST_LAB_TEST_METHOD_SUCCESS'
export const LIST_LAB_TEST_METHOD_FAIL = 'LIST_LAB_TEST_METHOD_FAIL'

export const CREATE_LAB_TEST_METHOD_REQUEST = 'CREATE_LAB_TEST_METHOD_REQUEST'
export const CREATE_LAB_TEST_METHOD_SUCCESS = 'CREATE_LAB_TEST_METHOD_SUCCESS'
export const CREATE_LAB_TEST_METHOD_FAIL = 'CREATE_LAB_TEST_METHOD_FAIL'

export const DETAIL_LAB_TEST_METHOD_REQUEST = 'DETAIL_LAB_TEST_METHOD_REQUEST'
export const DETAIL_LAB_TEST_METHOD_SUCCESS = 'DETAIL_LAB_TEST_METHOD_SUCCESS'
export const DETAIL_LAB_TEST_METHOD_FAIL = 'DETAIL_LAB_TEST_METHOD_FAIL'

export const UPDATE_LAB_TEST_METHOD_REQUEST = 'UPDATE_LAB_TEST_METHOD_REQUEST'
export const UPDATE_LAB_TEST_METHOD_SUCCESS = 'UPDATE_LAB_TEST_METHOD_SUCCESS'
export const UPDATE_LAB_TEST_METHOD_FAIL = 'UPDATE_LAB_TEST_METHOD_FAIL'

export const DELETE_LAB_TEST_METHOD_REQUEST = 'DELETE_LAB_TEST_METHOD_REQUEST'
export const DELETE_LAB_TEST_METHOD_SUCCESS = 'DELETE_LAB_TEST_METHOD_SUCCESS'
export const DELETE_LAB_TEST_METHOD_FAIL = 'DELETE_LAB_TEST_METHOD_FAIL'

export const RESET_STATE_LAB_TEST_METHOD = 'RESET_STATE_LAB_TEST_METHOD'

